import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../store/hooks";
// import { store } from "../../store/store";
import EventServices from "../../services/EventServices";
import { IEvent } from "../../store/eventApiSlice";
import MemberServices from "../../services/MemberServices";
import {
  // Outlet,
  useNavigate,
} from "react-router-dom";
// import EventList from "../Events/EventList";
import OrderEventList from "./orderEventList";
import OrderEventDetail from "./orderEventdetail";
import {
  Button,
  // SecondaryButton,
  PageLink,
  // Label,
} from "../StyledComp/StyledComp";
// import { changeCurrentMemberMenu } from "../../store/screenSlice";
// import { screenConfig } from "../../config/screenConfig";
import OrderServices from "../../services/OrderServices";
import {
  // orderApiSlice,
  resetOrderParameters,
  storeUpdateOrder,
  // IOrder,
} from "../../store/orderApiSlice";
// import MDEditSectionMultipleOptionItems from "../MemberDetail/MDEditSectionMultipleOptionItems";
import { ThemeProvider } from "styled-components";
import ReactModal from "react-modal";
import { TextField, createTheme } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { useForm, Controller } from "react-hook-form";
import * as routeConfig from "../../config/routes";
import { IPaymentInfo } from "../../store/memberInterfaceStruct";
import AlertWithModal from "../utilityComponents/AlertWithModal";

// interface IConfiguration {
//   [key: string]: any;
// }

interface ISection {
  Fee: number;
  Id: number;
  SectionDescription: string;
  SectionName: string;
  isSelected: boolean;
}

interface IMemberCode {
  Id: number;
  MemberCode: string;
  Description: string;
  Fee: number;
  FromYear: number;
  AdvanceMemberCode: string;
  Status: number;
}

// const memberCodeInit: IMemberCode = {
//   Id: 1,
//   MemberCode: "w",
//   Description: "w",
//   Fee: 1,
//   FromYear: 1,
//   AdvanceMemberCode: "w",
//   Status: 1,
// };

// interface ISection {
//   Fee: number;
//   Id: number;
//   SectionDescription: string;
//   SectionName: string;
//   isSelected: boolean;
// }

// interface ISelectedSections {
//   Id: number | null;
//   SectionName: string | null;
//   MemberId: number | null;
// }
interface IFunctionOrders {
  MemberId: number | null;
  OrderId: number | null;
  EventId: number | null;
  LocationId: number | null;
  CostId: number | null;
}

interface ISeminarOrders {
  MemberId: number | null;
  OrderId: number | null;
  EventId: number | null;
  LocationId: number | null;
  CostId: number | null;
}

interface IMemberShipOrders {
  Id: number | null;
  OrderId: number | null;
  MemberId: number | null;
  MemberCodeId: number | null;
  LastYearSections: string | null;
  CurrentYearSections: string | null;
  CurrentYearSectionsNotPaid: string | null;
  Description: string | null;
  Fee: number | null;
  MemberCode: string | null;
}

interface IActiveOrder {
  FunctioOrders: IFunctionOrders[];
  SeminarOrders: ISeminarOrders[];
  memberShipOrderDetails: IMemberShipOrders[];
}

const initalActiveOrder: IActiveOrder = {
  FunctioOrders: [],
  SeminarOrders: [],
  memberShipOrderDetails: [],
};

// don;t think this componenet is being used.
const UpdatePayment: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [SortField, setSortField] = useState("UniqueEventId");
  const currentMember = useAppSelector((state) => state.currentMember);
  const orderInfo = useAppSelector((store) => store.orderapislice);

  // const [OrderDetail, setOrderDetail] = useState<IOrder>(orderInfo);

  const [activeSeminarEvents, setactiveSeminarEvents] = useState<IEvent[]>([]);
  const [activeVideoEvents, setactiveVideoEvents] = useState<IEvent[]>([]);
  const [activeFunctionEvents, setactiveFunctionEvents] = useState<IEvent[]>(
    []
  );
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const [selectedEventType, setSelectedEventType] = useState<number>(2);
  const [currentEventScreen, setCurrentEventScreen] =
    useState<string>("OrderEventList");
  // const [currentscreen, setcurrentscreen] = useState<string>("OrderEventList");
  const [Sections, setSections] = useState<ISection[]>();
  const [memberCodes, setMemberCodes] = useState<IMemberCode[]>();

  const form = useForm<IPaymentInfo>();
  const { control } = form;

  const eventTypeCheckboxoptions = [
    { id: 1, label: "Sections" },
    { id: 2, label: "Membership" },
  ];

  // const eventTypeCheckboxoptions = [
  //   { id: 1, label: "Seminar" },
  //   { id: 2, label: "Video" },
  //   { id: 3, label: "Function" },
  //   { id: 4, label: "Sections" },
  //   { id: 5, label: "Membership" },
  // ];

  // const paymentInfoInitialState: IPaymentInfo = {
  //   PaymentMethod: "",
  //   DatePaid: dayjs(new Date("01/1/24")),
  //   CheckNumber: "",
  //   LateFee: 0,
  //   AuthCode: "",
  //   PIComments: "",
  //   NoInvoiceFlag: false,
  // };

  // const [PaymentInfo, setPaymentInfo] = useState<IPaymentInfo>(
  //   paymentInfoInitialState
  // );

  const [MembersActiveOrders, setMembersActiveOrders] =
    useState<IActiveOrder>(initalActiveOrder);

  // During first render, I don't want to set isActiveOrdersDataLoaded,
  // isActiveEventsDataLoaded and isSectionsDataLoaded as true
  let publishedAddress = currentMember.PublishedAddress;
  let pubAddress: string[] = [];
  publishedAddress?.Address1 && pubAddress.push(publishedAddress?.Address1);
  publishedAddress?.Address2 && pubAddress.push(publishedAddress?.Address2);
  publishedAddress?.City && pubAddress.push(publishedAddress?.City);
  publishedAddress?.County && pubAddress.push(publishedAddress?.County);
  publishedAddress?.State && pubAddress.push(publishedAddress?.State);
  publishedAddress?.Zipcode && pubAddress.push(publishedAddress?.Zipcode);
  // const [
  //   isFirstRenderOfActiveOrdersDataLoaded,
  //   setIsFirstRenderOfActiveOrdersDataLoaded,
  // ] = useState<boolean>(true);
  const [
    isFirstRenderOfActiveEventsDataLoaded,
    setIsFirstRenderOfActiveEventsDataLoaded,
  ] = useState<boolean>(true);
  // const [
  //   isFirstRenderOfSectionsDataLoaded,
  //   setIsFirstRenderOfSectionsDataLoaded,
  // ] = useState<boolean>(true);

  // const [isActiveOrdersDataLoaded, setIsActiveOrdersDataLoaded] =
  //   useState<boolean>(false);
  const [isActiveEventsDataLoaded, setIsActiveEventsDataLoaded] =
    useState<boolean>(false);
  // const [isSectionsDataLoaded, setIsSectionsDataLoaded] =
  //   useState<boolean>(false);

  console.log("Sections-create order:", Sections);
  useEffect(() => {
    console.log("create order useEFFECT CALLED", currentMember);

    if (currentMember.BarId === "") {
      // console.log("currentMember EMPTY");
      navigate("/member", { replace: false });
    }

    dispatch(resetOrderParameters());

    // const getActiveEventList = async () => {
    //   const response = await EventServices.getEventList();
    //   console.log("active events response...", response.data.data);
    //   if (response.data.data != null) {
    //     // console.log("Success:", response.data.data);
    //     setactiveSeminarEvents(
    //       response.data.data.Events.filter((event: IEvent) => {
    //         return (
    //           event.EventType === "Seminar" &&
    //           dayjs().isBefore(event.StartDateTime!)
    //         );
    //       })
    //     );
    //     setactiveFunctionEvents(
    //       response.data.data.Events.filter((event: IEvent) => {
    //         return (
    //           event.EventType === "Function" &&
    //           dayjs().isBefore(event.StartDateTime!)
    //         );
    //       })
    //     );
    //     setactiveVideoEvents(
    //       response.data.data.Events.filter((event: IEvent) => {
    //         return (
    //           event.EventType === "Video" &&
    //           dayjs().isBefore(event.StartDateTime!)
    //         );
    //       })
    //     );
    //     // setEventList(response.data.data.Events);
    //     // dispatch(updateEventList(response.data.data.Events));
    //   } else {
    //   }
    // };
    // getActiveEventList();

    const getOrderListsForMemberID = async () => {
      try {
        const response = await OrderServices.getOrderByMemberId(
          currentMember.Id!
        );
        if (response.data.data != null) {
          if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
          }
          console.log("Success-getOrderByMemberId:", response.data.data);
          setMembersActiveOrders(response.data.data);
          // setIsActiveOrdersDataLoaded(true);
        } else {
          // setIsActiveOrdersDataLoaded(true);
          // setIsActiveOrdersDataLoaded(false); // check this
        }
      } catch (error) {
        // setIsActiveOrdersDataLoaded(true);
        // setIsActiveOrdersDataLoaded(false); //check this
        // Handle errors from the API call
      }
    };

    getOrderListsForMemberID();

    const getConfigurationLists = async () => {
      try {
        const response = await MemberServices.getConfigurationList();
        if (response.data.data != null) {
          if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
          }
          console.log("Success:", response.data.data);
          // setConfigurationList(response.data.data);
          // setSectionIsSelectedFlag(response.data.data.MemberSection);
          dispatch(
            storeUpdateOrder({
              key: "Sections",
              value: response.data.data.MemberSection,
            })
          );

          // setTimeout(() => {
          //   // Code to be executed after 3 seconds
          //   setSections(response.data.data.MemberSection);
          //   // setMemberCodes(response.data.data.MemberCode);
          //   console.log("Execution resumed after 9 seconds");
          // }, 9000);
          // setting this state variable just to reload incase response from API is delayed
          setSections(response.data.data.MemberSection);
          setMemberCodes(response.data.data.MemberCode);
        }
      } catch (error) {
        // Handle errors from the API call
      }
    };

    getConfigurationLists();
  }, []);

  // useEffect(() => {
  //   console.log("SeminarEvents Count:", activeSeminarEvents.length);
  //   console.log("FunctionEvents Count:", activeFunctionEvents.length);
  //   console.log("VideoEvents Count:", activeVideoEvents.length);
  //   if (isFirstRenderOfActiveEventsDataLoaded) {
  //     setIsFirstRenderOfActiveEventsDataLoaded(false);
  //   } else {
  //     setIsActiveEventsDataLoaded(true);
  //   }
  // }, [activeSeminarEvents, activeFunctionEvents, activeVideoEvents]);

  // useEffect(() => {
  //   console.log(
  //     "SeminarOrders Count:",
  //     MembersActiveOrders.FunctioOrders.length
  //   );
  //   console.log(
  //     "FunctionOrders Count:",
  //     MembersActiveOrders.SeminarOrders.length
  //   );
  //   console.log(
  //     "memberShipOrderDetails Count:",
  //     MembersActiveOrders.memberShipOrderDetails.length
  //   );
  //   if (isFirstRenderOfActiveOrdersDataLoaded) {
  //     setIsFirstRenderOfActiveOrdersDataLoaded(false);
  //   } else {
  //     setIsActiveOrdersDataLoaded(true);
  //   }
  // }, [MembersActiveOrders]);

  // useEffect(() => {
  //   console.log("Sections count:", Sections?.length);
  //   //I dont want setIsSectionsDataLoaded to be called when first time
  //   // this useEffect is triggered. only want ot to be called only when useEffect
  //   // is triggered due to change in Sections state variable
  //   if (isFirstRenderOfSectionsDataLoaded) {
  //     setIsFirstRenderOfSectionsDataLoaded(false);
  //   } else {
  //     setIsSectionsDataLoaded(true);
  //   }
  // }, [Sections]);

  const onEventScreenChange = (eventScreen: string) => {
    setCurrentEventScreen(eventScreen);
    console.log("eventScreen:", eventScreen);
  };

  const handleEventTypeRadioChange = (id: number) => {
    setSelectedEventType(id);
    onEventScreenChange("OrderEventList");
  };

  const [modalOpen, setModalOpen] = useState(false);

  const handleCancel = () => {
    setModalOpen(false);
  };

  const updatePaymentInfo = (e: any, date?: Date | null) => {
    switch (e.target.name) {
      case "PaymentMethod":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   PaymentMethod: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "PaymentMethod",
            value: e.target.value,
          })
        );
        break;

      case "DatePaid":
        // const formattedDate = date ? dayjs(date) : null;
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   DatePaid: formattedDate,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "DatePaid",
            value: e.target.value,
          })
        );

        break;

      case "CheckNumber":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   CheckNo: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "CheckNumber",
            value: e.target.value,
          })
        );
        break;

      case "AmountPaid":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   AmountPaid: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "AmountPaid",
            value: e.target.value,
          })
        );
        break;

      case "LateFee":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   LateFee: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "LateFee",
            value: e.target.value,
          })
        );
        break;

      case "AuthCode":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   AuthCode: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "AuthCode",
            value: e.target.value,
          })
        );
        break;

      case "PIcomments":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   PIComments: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "comments",
            value: e.target.value,
          })
        );
        break;

      case "NoInvoiceFlag":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   NoInvoiceFlag: false,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "NoInvoice",
            value: e.target.checked,
          })
        );
        break;

      default:
        console.log("default");
        break;
    }
  };

  const onSubmit = async (e: any) => {
    e.preventDefault();
    console.log("onSUBMIT:", orderInfo);
    setModalOpen(false);
    const apiBody: any = orderInfo;
    const response = await OrderServices.createOrder(apiBody);
    // console.log("response", response);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      alert("Order Created successfully");
      // dispatch(resetOrderParameters());  I am doing this in useEffect
      // navigate("/order", { replace: true });
      // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
      // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));

      dispatch(
        storeUpdateOrder({
          key: "TransactionAmount",
          value: 0,
        })
      );

      // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
      navigate("/member/findmember", { replace: false });
      // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
      //  dispatch(screenChange("Events"));
    } else {
      alert(response.data.errors);
      console.log("error");
    }
  };

  const color1 = "#2d6289";
  // const color2 = "#008800";

  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        error: {
          main: color1,
        },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });

  const cancelOrder = () => {
    navigate(routeConfig.MEMBERS_URL, { replace: false });
  };

  return (
    <div className="dashboard-wrapper" style={{ paddingBottom: "100px" }}>
      {/* personal info */}
      {/* <div className="dashboard-content-wrapper"> */}
      {/* member info */}

      <div className="horizontal-wrapper-spacebetween">
        <h1 className="page-heading">Create Order</h1>
        <div
          style={{ cursor: "pointer", paddingRight: "0rem", color: "blue" }}
          onClick={cancelOrder}
          className="pt-1"
        >
          <PageLink>Cancel </PageLink>
        </div>
      </div>

      <div className="section-box">
        <div className="horizontal-wrapper-spacebetween">
          <h3 className="section-heading">Personal Information</h3>
        </div>
        <div className="form-wrapper-smaller-grid">
          {/* line 1 */}
          <div className="input-field-div-wrapper-smaller-griditem">
            <input
              className="input-field-div-small"
              id="FirstName"
              name="FirstName"
              disabled={true}
              value={currentMember.BarId != "" ? currentMember.FirstName : ""}
            />
            <label className="form-label" htmlFor="FirstName">
              First Name
            </label>
          </div>
          <div className="input-field-div-wrapper-smaller-griditem">
            <input
              className="input-field-div-small"
              id="LastName"
              name="LastName"
              disabled={true}
              value={currentMember.BarId != "" ? currentMember.LastName : ""}
            />
            <label className="form-label" htmlFor="LastName">
              Last Name
            </label>
          </div>
          <div className="input-field-div-wrapper-smaller-griditem">
            <input
              className="input-field-div-small"
              id="BarId"
              name="BarId"
              disabled={true}
              value={currentMember.BarId != "" ? currentMember.BarId : ""}
            />
            <label className="form-label" htmlFor="BarId">
              BarID
            </label>
          </div>
          <div className="input-field-div-wrapper-smaller-griditem">
            <input
              className="input-field-div-small"
              id="MemberCode"
              name="MemberCode"
              disabled={true}
              value={
                currentMember.BarId != ""
                  ? currentMember.MemberCode + "-" + currentMember.Description!
                  : ""
              }
            />
            <label className="form-label" htmlFor="LastName">
              Member Code
            </label>
          </div>

          {/* line 2 */}

          <div className="input-field-div-wrapper-smaller-griditem">
            <input
              className="input-field-div-small"
              id="FirmName"
              name="FirmName"
              disabled={true}
              value={
                currentMember.BarId != ""
                  ? currentMember.PublishedAddress!.FirmName!
                  : ""
              }
            />
            <label className="form-label" htmlFor="FirmName">
              Firm Name
            </label>
          </div>
          <div className="input-field-div-wrapper-smaller-griditem">
            <input
              className="input-field-div-small"
              id="PhoneNumber"
              name="PhoneNumber"
              disabled={true}
              value={
                currentMember.BarId != ""
                  ? currentMember.PublishedAddress!.PhoneNumber
                  : ""
              }
            />
            <label className="form-label" htmlFor="PhoneNumber">
              Phone Number
            </label>
          </div>
          <div className="input-field-div-wrapper-smaller-griditem">
            <input
              className="input-field-div-small"
              id="Email"
              name="Email"
              disabled={true}
              value={
                currentMember.BarId != ""
                  ? currentMember.PublishedAddress!.Email
                  : ""
              }
            />
            <label className="form-label" htmlFor="Email">
              Email ID
            </label>
          </div>
          {/* line 3 */}
          <div className="input-field-div-wrapper-large-griditem">
            <input
              className="input-field-div-small"
              id="Address"
              name="Address"
              //
              disabled={true}
              // value={
              //   currentMember.BarId != ""
              //     ? typeof currentMember.PublishedAddress != "undefined"
              //       ? currentMember.PublishedAddress!.Address1 +
              //         ", " +
              //         currentMember.PublishedAddress!.Address2 +
              //         ", " +
              //         currentMember.PublishedAddress!.County +
              //         ", " +
              //         currentMember.PublishedAddress!.State
              //       : ""
              //     : ""
              // }
              value={pubAddress}
            />
            <label className="form-label" htmlFor="Address">
              Address
            </label>
          </div>
        </div>
      </div>

      {/* Order detail */}
      <div className="section-box">
        {/* Event button group */}
        <div
          className="horizontal-wrapper-leftaligned"
          style={{ marginBottom: "0.8rem", width: "70%" }}
        >
          {eventTypeCheckboxoptions.map((option) => (
            <div key={option.id} className="checkboxgroup-ordertype">
              <input
                id={`checkbox-${option.id}`}
                className="checkbox-find"
                name="OrderType"
                type="radio"
                checked={selectedEventType === option.id}
                onChange={(e) => handleEventTypeRadioChange(option.id)}
              />
              <span style={{ marginRight: "0.1rem" }}>{option.label}</span>
            </div>
          ))}
        </div>

        <div style={{ widows: "100%" }}>
          {/* Sections */}
          {selectedEventType === eventTypeCheckboxoptions[0].id ? (
            <div className="overflow-auto">
              <h3 className="section-heading">Sections</h3>
              <>
                {/* {isActiveOrdersDataLoaded && isSectionsDataLoaded ? ( */}
                {typeof Sections === "undefined" ? (
                  <>Loading</>
                ) : MembersActiveOrders.memberShipOrderDetails.length > 0 &&
                  Sections!.length > 0 ? (
                  <OrderEventDetail
                    eventType={eventTypeCheckboxoptions[0].label}
                    currentMember={currentMember}
                    membersActiveOrders={MembersActiveOrders}
                    Sections={Sections}
                    onEventScreenChange={(eventScreen: string) =>
                      onEventScreenChange(eventScreen)
                    }
                  />
                ) : (
                  <>Sections not avilable</>
                )}
              </>
            </div>
          ) : (
            <></>
          )}

          {/* Membership */}
          {selectedEventType === eventTypeCheckboxoptions[1].id ? (
            <div className="overflow-auto">
              <h3 className="section-heading">Membership</h3>
              <>
                {typeof memberCodes === "undefined" ? (
                  <>Loading</>
                ) : memberCodes!.length > 0 ? (
                  <OrderEventDetail
                    eventType={eventTypeCheckboxoptions[1].label}
                    currentMember={currentMember}
                    membersActiveOrders={MembersActiveOrders}
                    Sections={Sections}
                    memberCodes={memberCodes}
                    onEventScreenChange={(eventScreen: string) =>
                      onEventScreenChange(eventScreen)
                    }
                  />
                ) : (
                  <>Member Code not available</>
                )}
              </>
              {/* <div className="form-wrapper">
                  {typeof Sections != "undefined" ? (
                    <div className="sections-section">
                      {Sections.map((section: ISection) => (
                        <MDEditSectionMultipleOptionItems
                          section={section}
                          // isSection={true}
                          onChangeFunction={handleMembershipChange}
                        />
                      ))}
                    </div>
                  ) : (
                    <>
                    </>
                  )}
                </div> */}
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      {/* </div> */}
      {/* <div className="button-wrapper">
        <button
          className="submit-button-div"
          type="submit"
          onClick={() => setModalOpen(true)}
          disabled={orderInfo.Orders.length == 0 ? true : false}
        >
          Create Order
        </button>
      </div> */}
      <ReactModal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Edit Personal Information</h1>
          <PageLink onClick={handleCancel}>Cancel</PageLink>
        </div>
        <form className="form-wrapper" onSubmit={onSubmit} noValidate>
          {/* <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="PaymentMethod"
              name="PaymentMethod"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="PaymentMethod">
              Payment Method
            </label>
          </div> */}

          <div className="input-field-div-wrapper">
            <select
              className="dropdown-control-large-insidetextfield"
              name="PaymentMethod"
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
            >
              <option value={""}> Select Payment Type </option>
              <option value="Online">American Express</option>
              <option value="Offline">Authorize.net</option>
              <option value="Check">Check</option>
              <option value="Discover">Discover</option>
              <option value="MasterCard">MasterCard</option>
              <option value="Visa">Visa</option>
              <option value="Offline">Website</option>
            </select>
          </div>

          <div style={{ width: "28%", marginBottom: "1.8rem" }}>
            <Controller
              control={control}
              name="DatePaid"
              // rules={{ required: "* required field" }}
              render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { error },
              }) => (
                <ThemeProvider theme={muiDatePickerColorTheme}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="datepicker-local"
                      label="Date Paid"
                      value={value ? dayjs(value).toDate() : null}
                      onChange={(date: Date | null) => {
                        const formattedDate = date
                          ? dayjs(date).format("YYYY-MM-DD")
                          : null;
                        const syntheticEvent = {
                          target: {
                            name: "DatePaid",
                            value: date
                              ? dayjs(date).format("YYYY-MM-DD")
                              : null,
                          },
                        };
                        updatePaymentInfo(syntheticEvent, date);
                      }}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              )}
            />
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="CheckNumber"
              name="CheckNumber"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="CheckNumber">
              Check Number
            </label>
          </div>
          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="AmountPaid"
              name="Amount Paid"
              pattern="[0-9]*"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              value={orderInfo.TotalAmount}
              disabled={true}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="AmountPaid">
              Amount Paid
            </label>
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="LateFee"
              name="LateFee"
              placeholder=""
              pattern="[0-9]*"
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="LateFee">
              Late Fee
            </label>
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="AuthCode"
              name="AuthCode"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="AuthCode">
              Auth Code
            </label>
          </div>

          <div className="textarea-wrapper" style={{ width: "100%" }}>
            <TextField
              className="textarea"
              id="PIcomments"
              name="PIcomments"
              placeholder=""
              multiline
              rows={3}
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
            />
            <label className="form-label" htmlFor="PIcomments">
              Comments
            </label>
          </div>

          <div className="order-checkboxgroup">
            <input
              id="NoInvoiceFlag"
              name="NoInvoiceFlag"
              className="checkbox"
              type="checkbox"
              onChange={(e) => updatePaymentInfo(e)}
            />
            <div>
              <span> No Invoice</span>
            </div>
          </div>
          <div className="horizontal-wrapper-centeralign">
            <div className="submit-button-div ">
              <Button
                type="submit"
                // onClick={onSubmit}
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>

    //     <div className="horizontal-wrapper-spacebetween">
    //       <div className="checkboxdiv">
    //         {sections.map((section, index) => (
    //           <div key={section.Id} className="checkboxgroup-find">
    //             <input
    //               id={section.Id}
    //               className="checkbox-find"
    //               name={section.Id}
    //               type="radio"
    //               onChange={(e) => props.onChangeFunction(e, true)}
    //             />
    //             <div className="section-text" style={{ fontWeight: "500" }}>
    //               {section.Cost} {section.SectionName}
    //             </div>
    //           </div>
    //         ))}
    //       </div>
    //     </div>
    //   </div>
    // </>*/}
  );
};

export default UpdatePayment;
